import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { BRIEFINGS_GET } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';


const api_get_briefings_dash = (data) => {
    return (dispatch, getState) => {
        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            // [HttpGet("/api/Dashboard/client/{clientId}/eventBriefingType/{from}/{to}")]

            return axios.get(`${Config.API_BASE_URL}/dashboard/${data.prefix}/${data.idGet}/eventBriefingType/${data.fromDate}/${data.toDate}?status=${data.status}`, config)
                .then(response => {



                    dispatch({
                        type: BRIEFINGS_GET,

                        payload: {
                            briefings: response.data,
                            errors: {},
                        }
                    })
                })
                .catch(error => {
                    dispatch({
                        type: BRIEFINGS_GET,
                        payload: {
                            errors: {},
                            task: {
                                result: false
                            }
                        }
                    })
                });
        }).catch(error => {
            dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_briefings_dash;
